export default __webpack_public_path__ + "static/media/_DSC0830.8496a8ad.JPG";